import { useColorModeValue, SystemStyleObject, rem, useToken } from '@vimeo/bokeh';

interface IUseScrollbarStylesProps {
  width?: string;
  scrollbarColor?: string;
  thumbColor?: string;
}

export function useScrollbarStyles({
  width = rem(16),
  scrollbarColor = 'surface',
  // eslint-disable-next-line react-hooks/rules-of-hooks
  thumbColor = useColorModeValue('darkBlueAlpha.200', 'lightBlueAlpha.200'),
}: IUseScrollbarStylesProps = {}): SystemStyleObject {
  const [thumbColorVariable, scrollbarColorVariable] = useToken(
    'colors',
    [thumbColor, scrollbarColor],
    [thumbColor, scrollbarColor],
  );

  return {
    '&::-webkit-scrollbar': {
      width: width,
    },

    '&::-webkit-resizer, &::-webkit-scrollbar-corner, &::-webkit-scrollbar-track': {
      backgroundColor: scrollbarColor,
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: thumbColor,
      borderRadius: width,
      border: `${rem(4)} solid`,
      borderColor: scrollbarColor,
    },

    '&::-webkit-scrollbar-button': {
      display: 'none',
    },

    // Following styles are for Firefox
    '@supports (-moz-appearance: none)': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${thumbColorVariable} ${scrollbarColorVariable}`,
    },
  };
}
